import { useQuery } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';

import ErrorMessage from 'components/ErrorMessage';
import PortfolioStatistics from 'components/PortfolioStatistics';

import LoadingIndicator from 'primitives/LoadingIndicator';

import { getEndOfLastQuarter } from 'utils/format-helper';

const STATISTICS_QUERY = gql(`
  query getStatisticsOfInvestmentEntities($id: ID!) {
    investmentEntity(id: $id) {
      id
      statistics {
        totalInvestedAmount
        totalRealizedValue
        totalUnrealizedValue
        moic
        xirr
      }
    }
  }
`);

const StatisticsOfInvestmentEntities: FC<{ investmentEntityId: string }> = ({
  investmentEntityId,
}) => {
  const { loading, error, data, refetch } = useQuery(STATISTICS_QUERY, {
    variables: {
      id: investmentEntityId,
    },
  });

  if (loading) return <LoadingIndicator />;

  if (error || !data) return <ErrorMessage error={error} refetch={refetch} />;

  const { totalInvestedAmount, totalUnrealizedValue, totalRealizedValue, moic, xirr } =
    data.investmentEntity.statistics;

  return (
    <PortfolioStatistics
      statistics={[
        {
          label: 'Total Amount Invested',
          value: totalInvestedAmount,
          type: 'CURRENCY',
        },
        {
          label: 'Unrealized Value',
          value: totalUnrealizedValue,
          type: 'CURRENCY',
        },
        {
          label: 'Realized Value',
          value: totalRealizedValue,
          type: 'CURRENCY',
        },
        {
          label: 'Multiple on Invested Capital',
          value: moic,
          type: 'MULTIPLE',
        },
        {
          label: 'XIRR',
          value: xirr,
          type: 'PERCENTAGE',
          helperText: `As of ${getEndOfLastQuarter().toLocaleDateString()}`,
        },
      ]}
    />
  );
};

export default StatisticsOfInvestmentEntities;
